import { loadLoyaltyIsBenefitAvailable } from ".";
import { EARLY_ACCESS_SALE } from "../constants";

const loadLoyaltyIsEarlyAccessSaleAvailableForTier = () => async dispatch => {
  dispatch(loadLoyaltyIsBenefitAvailable(EARLY_ACCESS_SALE));
};

export default loadLoyaltyIsEarlyAccessSaleAvailableForTier;
